import React, { forwardRef, useImperativeHandle, useState, useEffect, useRef } from 'react';

//* import css
import cssClasses from "./CreateUser.module.css";

//* import sub-component
import CustomInput from '../../../Subcomponents/CustomInput';
import Button from '../../../Subcomponents/Button';
import ConfirmationAlert from '../../../Subcomponents/ConfirmationAlert';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { updateUser } from '../../../Services/Users';
import { errorTost, successTost } from '../../../Services/Toast';

const Target = forwardRef(({ userObject, setUserObject },ref) => {

  const isLeaveComponentPromise = useRef(null);

  const [targetAmount, setTargetAmount] = useState("");
  const [targetAmountHelperText, setTargetAmountHelperText] = useState("");
  const [confirmationAlertToggler, setConfirmationAlertToggler] = useState(false);

  useEffect(() => {
    setTargetAmount(userObject?.targetAmount ? userObject.targetAmount : "")
  }, [userObject])

  useImperativeHandle(ref, () => ({
    isLeaveComponent
  }));

  function isLeaveComponent() {
    return new Promise((resolve, reject) => {
      if (userObject.targetAmount === targetAmount) {
        resolve(true);
      } else {
        setConfirmationAlertToggler(true);
        isLeaveComponentPromise.current = resolve;
      }
    })
  }

  function saveTarget() {
    if (isAmountValid(targetAmount).flag) {
      updateUserToServer();
    } else {
      setTargetAmountHelperText(isAmountValid(targetAmount).helperText)
    }
  }

  async function updateUserToServer() {
    let postBody = {
      targetAmount: targetAmount
    }
    presentLoader();
    const updateUserResponse = await updateUser(postBody, userObject?.userId);
    if (updateUserResponse.data) {
      setUserObject({...updateUserResponse.data});
      successTost("User details updated successfully.");
      dismissLoader();
    } else {
      if (updateUserResponse?.error?.message) {
        errorTost(updateUserResponse?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }


  return (
    <>
      <div className={cssClasses.assignRoleWrapper}>
        <div>
          <div className={cssClasses.inputWrapper}>
            <label>Set Target <span>*</span></label>
            <CustomInput
              placeholder='Enter Target Amount'
              value={targetAmount}
              helperText={targetAmountHelperText}
              handleChange={(_value) => {
                if ((+_value || _value === "") && _value.length <= 10) {
                  setTargetAmount(_value);
                  let _isValid = isAmountValid(_value);
                  setTargetAmountHelperText(_isValid.helperText);
                }
              }}
            />
          </div>

        </div> 
        <div>

        </div>
      </div>

      <div className={cssClasses.buttonWrapper}>
        <div>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            btnName={"Assign Target"}
            clicked={() => {
              saveTarget();
            }}
            // btnIcon={<AddIcon style={{width: "15px", height: "15px"}}/>}
            iconPosition={"left"}
          />
        </div>
      </div>

      <ConfirmationAlert 
        open={confirmationAlertToggler} 
        title={"Warning"} 
        subTitle={"Unsaved Changes! Do you want to continue without saving."} 
        confirm={(_value) => {
          console.log(_value); 
          if (_value === "rejected") {
            setConfirmationAlertToggler(false);
            isLeaveComponentPromise.current(false);
          } else {
            setConfirmationAlertToggler(false);
            isLeaveComponentPromise.current(true);
          }
        }} 
        buttonTitle={"Cancel"} 
        returnRespButton={"Continue"} 
        close={() => {setConfirmationAlertToggler(false)}}
      />
    </>
  )
})

export default Target;

function isAmountValid(inputText) {
  inputText = inputText?.toString();
  let flag = true;
  let helperText = "";
  if (inputText === "") {
    flag = false;
    helperText = `Please enter valid amount.`;
  }
  return { flag, helperText };
}